<template>
  <div class="noticia-card transform-container">
    <router-link
      v-if="props.noticia.id"
      :to="`/home-noticia/${props.noticia.id}`"
      class="noticia-link"
    >
      <div class="noticia-imagem">
        <img
          :src="props.noticia.imagemUrl"
          :alt="props.noticia.titulo"
        />
      </div>
      <div class="noticia-texto">
        <span class="titulo">
          <span
            v-if="props.noticia.acaoSigla"
            class="sigla-inline-badge"
            :style="getCorSigla()"
          >
            {{ props.noticia.acaoSigla.toUpperCase() }}
          </span>
          <span v-if="props.noticia.acaoSigla"> - </span
          ><span class="titulo-texto"> {{ props.noticia.titulo }}</span>
        </span>
        <span class="data-publicacao">
          {{ formatarData(props.noticia.dataPublicacao) }}
        </span>
        <span class="info">{{ props.noticia.texto }}</span>
        <div
          v-if="
            props.noticia.palavrasChaves && props.noticia.palavrasChaves.length
          "
          class="palavras-chave"
        >
          <span
            v-for="palavra in props.noticia.palavrasChaves"
            :key="palavra"
            class="tag"
          >
            {{ palavra }}
          </span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script setup>
import { formatarData } from "@/utils/FormatarEntradas";

const props = defineProps({
  noticia: {
    type: Object,
    required: true,
  },
});

function getCorSigla() {
  return {
    backgroundColor: props.noticia.acaoCorSigla || "#48298a",
    borderColor: props.noticia.acaoCorSigla || "#48298a",
  };
}
</script>

<style scoped>
.noticia-card {
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 0.4rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.noticia-link {
  display: flex;
  align-items: flex-start;
  padding: 15px;
  text-decoration: none;
  color: inherit;
  gap: 16px;
}

.noticia-imagem {
  flex-shrink: 0;
  width: 250px;
  height: 150px;
  border-radius: 6px;
  overflow: hidden;
}

.noticia-imagem img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.noticia-texto {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex: 1;
}

.sigla-inline-badge {
  display: inline-block;
  padding: 2px 6px;
  font-size: 0.8rem;
  font-weight: 700;
  border-radius: 4px;
  margin-right: 4px;
  vertical-align: middle;
  border: 1px solid transparent;
  line-height: 1.2;
  color: #ffffff;
}

.noticia-texto .titulo {
  font-size: 1.375rem;
  font-weight: 600;
  color: #333;
}

.data-publicacao {
  font-size: 0.82rem;
  color: #8a8a8a;
  font-weight: 500;
}

.info {
  font-size: 0.95rem;
  color: #555;
  margin-left: 0;

  line-height: 1.4;
  min-height: calc(1.4em * 2);

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.palavras-chave {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-top: 0.4rem;
}

.tag {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.65rem;
  border-radius: 999px;
  background-color: #ece5ff;
  color: #563578;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
}
</style>
